import React from 'react';

export const styles = () => {
  return {
    actionItemsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      cursor: 'pointer',
    } as React.CSSProperties,
    actionItemsTextsContainer: {
      display: 'flex',
      flexDirection: 'column',
    } as React.CSSProperties,
    actionItemsTitleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    } as React.CSSProperties,
    imageContainer: {
      width: 32,
      height: 32,
      borderRadius: 4,
      position: 'relative' as 'relative',
      overflow: 'hidden' as 'hidden',
    } as React.CSSProperties,
    landscapeImage: {
      position: 'absolute' as 'absolute',
      left: '-100%',
      right: '-100%',
      top: '-100%',
      bottom: '-100%',
      margin: 'auto' as 'auto',
      minWidth: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      objectFit: 'cover' as 'cover',
    } as React.CSSProperties,
    portraitImage: {
      position: 'absolute' as 'absolute',
      left: '-100%',
      right: '-100%',
      top: '-100%',
      bottom: '-100%',
      margin: 'auto' as 'auto',
      minWidth: '100%',
      minHeight: '100%',
      maxWidth: '100%',
      objectFit: 'cover' as 'cover',
    } as React.CSSProperties,
    squareImage: {
      position: 'absolute' as 'absolute',
      left: '-100%',
      right: '-100%',
      top: '-100%',
      bottom: '-100%',
      margin: 'auto' as 'auto',
      minWidth: '100%',
      minHeight: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover' as 'cover',
    } as React.CSSProperties,
  };
};
